<template>
  <div>
    <div
      v-if="userId"
      class="heart heart--transition"
      :class="{
        memorised: isMemorised,
        'heart--transition': effectOn,
      }"
      @click="memorisedArtwork"
      @mouseover="removeEffect"
      :id="tooltipId"
    >
      <span class="icon icon-heart heart__shape" />
      <span class="heart__fill" />
      <div
        class="heart__effect"
        :class="{ animation: startEffect }"
      />
    </div>
    <a
      v-else
      class="heart heart--transition"
      :href="new_user_session_path"
      :id="tooltipId"
     >
      <span class="icon icon-heart heart__shape" />
      <span class="heart__fill" />
    </a>
    <b-tooltip
      v-if="!isMemorised"
      :target="tooltipId"
      placement="topleft"
    >
      {{ I18n.t('artworks.memorise') }}
    </b-tooltip>
  </div>
</template>

<script>
/* global Routes */
import { mapState } from 'vuex';

export default {
  name: 'ArtworkMemorise',
  props: {
    artwork: {
      type: Object,
      required: true,
    },
    modal: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      new_user_session_path: Routes.new_user_session_path(),
      effectOn: true,
      startEffect: false,
      baseUrl: null,
      bodyClass: 'memorised',
    };
  },
  methods: {
    memorisedArtwork() {
      const requestType = this.isMemorised ? 'DELETE' : 'POST';
      const urlModifier =
        this.isMemorised ? this.artwork.id : `add_artwork?artwork_id=${this.artwork.id}`;

      this.$http({
        method: requestType,
        url: `${this.baseUrl}/api/v1/users/memorised_artworks/${urlModifier}`,
      }).then(() => {
        if (this.isMemorised) {
          this.effectOn = false;
        } else {
          this.startEffect = true;

          setTimeout(() => {
            this.startEffect = false;
          }, 5000);
        }

        this.$emit('handleMemoriseResponse', this.artwork.id);
      });
    },
    removeEffect() {
      this.effectOn = true;
    },
  },
  computed: {
    ...mapState(['userId']),
    tooltipId() {
      if (this.modal) {
        return `memoriseModal${this.artwork.id}`;
      }
      return `memorise${this.artwork.id}`;
    },
    isMemorised() {
      return this.artwork.memorised;
    },
  },
  mounted() {
    this.baseUrl = window.location.origin;
    document.body.classList.add(this.bodyClass);
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/artwork_memorise.vue?30772b1d